import { render, staticRenderFns } from "./callBack.vue?vue&type=template&id=b27ee262&scoped=true"
import script from "./callBack.vue?vue&type=script&lang=js"
export * from "./callBack.vue?vue&type=script&lang=js"
import style0 from "./callBack.vue?vue&type=style&index=0&id=b27ee262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27ee262",
  null
  
)

export default component.exports